import { Alert, Typography, useTheme } from "@mui/material";
import { Info } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

export const RefinancingPropertyPriceNotice: FC = () => {
	const { t } = useResource();
	const { palette, iconSize, spacingTokens } = useTheme();

	return (
		<Alert
			variant="notice"
			severity="info"
			icon={<Info size={iconSize.sm} />}
			sx={{
				mx: spacingTokens.lg,
				mt: spacingTokens.md,
				p: spacingTokens.lg,
			}}
		>
			<Typography variant="body2" color={palette.grey[900]}>
				{t(Resources.Calculators.Refinancing.PropertyPriceMissing)}
			</Typography>
		</Alert>
	);
};
